import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { emptyButtonStyle } from './styles/shared-styles';

const loadMoreStyle = _.defaults({
  width: '100%',
}, emptyButtonStyle);

export class LoadMoreButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inViewPort: false,
    };

    this.target = null;
    this.observer = null;
    this.intersected = false;
  }

  componentDidMount() {
    this.initIntersectionObserver();
    this.startObserver();
  }

  componentDidUpdate() {
    if (this.state.inViewPort) {
      this.props.onLoadMore();
    }
  }

  startObserver = () => {
    if (this.target && this.observer) {
      this.observer.observe(this.target);
    }
  };

  stopObserver = () => {
    if (this.target && this.observer) {
      this.observer.unobserve(this.target);
      this.observer.disconnect();
      this.observer = null;
    }
  };

  handleIntersection = (entries) => {
    if (this.props.isAutoLoadMore) {
      const entry = entries[0] || {};
      const { isIntersecting, intersectionRatio } = entry;
      const isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;

      // enter
      if (!this.intersected && isInViewport) {
        this.intersected = true;
        this.setState({
          inViewPort: true,
        });

        return;
      }

      // leave
      if (this.intersected && !isInViewport) {
        this.intersected = false;

        this.setState({
          inViewPort: false,
        });
      }
    }
  };

  initIntersectionObserver = () => {
    if (!this.observer) {
      this.observer = new IntersectionObserver(this.handleIntersection, {});
    }
  };

  render() {
    return (
      <button
        className="load-more-button"
        onClick={this.props.onLoadMore}
        style={loadMoreStyle}
        ref={(node) => { this.target = node; return node; }}
        aria-label={_TL_('Load more images')}
      >
        {
          !this.props.isAutoLoadMore &&
          <svg
            width="100px"
            height="100px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            className="lds-ellipsis"
            style={{ background: 'none' }}
          >
            <circle cx="84" cy="50" r="0" fill="#008272">
              <animate attributeName="r" values="10;0;0;0;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="0s" />
              <animate attributeName="cx" values="84;84;84;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="0s" />
            </circle>
            <circle cx="47.5763" cy="50" r="10" fill="#008272">
              <animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="-1s" />
              <animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="-1s" />
            </circle>
            <circle cx="16" cy="50" r="9.28715" fill="#008272">
              <animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="-0.5s" />
              <animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="-0.5s" />
            </circle>
            <circle cx="84" cy="50" r="0.712853" fill="#008272">
              <animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="0s" />
              <animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="0s" />
            </circle>
            <circle cx="81.5763" cy="50" r="10" fill="#008272">
              <animate attributeName="r" values="0;0;10;10;10" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="0s" />
              <animate attributeName="cx" values="16;16;16;50;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="2s" repeatCount="indefinite" begin="0s" />
            </circle>
          </svg>
        }
      </button>
    );
  }
}

LoadMoreButton.propTypes = {
  onLoadMore: PropTypes.func.isRequired,
  isAutoLoadMore: PropTypes.bool,
};

LoadMoreButton.defaultProps = {
  isAutoLoadMore: false,
};
